import { axiosJsonInstance } from "@/axios.instance";
import { AxiosInstance } from "axios";
import { VideoReportRequest, CameraRecordingState } from "@/store/video-reporting/types";

class VideoReportingApi {
	private axios: AxiosInstance;

	constructor() {
		this.axios = axiosJsonInstance;
	}

	private sanitiseReportRequest(reportRequest: VideoReportRequest): VideoReportRequest {
		for (let search of reportRequest.search) {
			if (search.searchResults) delete search.searchResults;

			if (search.cameras) {
				for (let camera of search.cameras) {
					camera["settingsMeta"] = null;
				}
			}
		}

		return reportRequest;
	}

	public async getVideoReportingPrefs(): Promise<any> {
		const { data } = await this.axios.get("/VideoReporting/Prefs");
		return data;
	}

	public async uploadBulkDeviceSearch(
		fileToUpload: File,
		onProgressUpdate: (newProgress: number) => void
	): Promise<any> {
		const formData = new FormData();
		formData.append("file", fileToUpload, fileToUpload.name);

		const requestConfig = {
			onUploadProgress: (progressEvent: ProgressEvent) => {
				// When axios sends us an upload progress event, invoke our callback with the % figure
				let percentComplete = Math.round((progressEvent.loaded * 100) / progressEvent.total);
				onProgressUpdate(percentComplete);
			}
		};

		const { data } = await this.axios.put("/VideoReporting/ProcessBulkSearch", formData, requestConfig);
		return data;
	}

	public async search(searchRequest: VideoReportRequest): Promise<any> {
		const { data } = await this.axios.post("/VideoReporting/Search", this.sanitiseReportRequest(searchRequest));
		return this.sanitiseReportRequest(data);
	}

	public async createReport(reportRequest: VideoReportRequest): Promise<number> {
		const { data } = await this.axios.post("/VideoReporting/Report", this.sanitiseReportRequest(reportRequest));
		return data;
	}

	public async createDeviceReportRecord(reportEventId: number, deviceId: number): Promise<number> {
		const { data } = await this.axios.post(`/VideoReporting/Device/${reportEventId}/${deviceId}`);
		return data;
	}

	public async createCameraReportRecord(
		cameraDeviceId: number,
		reportEventId: number,
		messages: string[],
		state: CameraRecordingState
	) {
		const { data } = await this.axios.post("/VideoReporting/Camera", {
			cameraDeviceId,
			reportEventId,
			messages,
			state
		});
		return data;
	}
}

const videoReportingApi = new VideoReportingApi();
export default videoReportingApi;
